(function() {

    function apply () {
        $('form').each(function () {

            var $buffer = $('<div />');
            $buffer.html($(this).find('noscript').text().replace(/&lt;/g, '<').replace(/&gt;/g, '>'));

            var key = $buffer.find('label').find('strong').text();
            var name = $buffer.find('.anti-fill').attr('name');

            $(this).append($('<input type="hidden" name="' + name + '" value="' + key + '">'));

        });
    }

    apply();

    $(document).on('load:afterRender', apply);

})();


// WEBPACK FOOTER //
// ./modules/antispam.js